<ui-bottom-sheet
  [open]="open()"
  [title]="title()"
  [description]="description()"
  closeLabel="Zamknij"
  [closeOnBackdrop]="!pending()"
  size="lg"
  snap="large"
  (closed)="handleClosed()"
>
  <div class="wishlist-detail-reservation-drawer">
    @if (isQaScenario) {
      <ui-inline-message
        text="Środowisko testowe — nie używaj prawdziwych danych rodziny. Potwierdzenie dotyczy scenariusza QA; nie weryfikuje tożsamości ani własności wpisanego adresu."
        tone="warning"
      />
    }
    @if (success()) {
      <ui-success-state
        [title]="title()"
        [description]="description()"
        aria-live="polite"
      />
      @if (errorMessage()) {
        <ui-inline-message
          [text]="errorMessage() ?? ''"
          tone="danger"
          ariaLive="polite"
        />
      }
      @if (!confirmed()) {
        <ui-button
          [fullWidth]="true"
          [disabled]="pending()"
          (pressed)="resent.emit()"
          >Wyślij ponownie</ui-button
        >
        <ui-button
          [fullWidth]="true"
          [disabled]="pending()"
          (pressed)="correctionRequested.emit()"
          >Popraw email</ui-button
        >
      }
      <ui-button
        [fullWidth]="true"
        [disabled]="pending()"
        (pressed)="handleClosed()"
        >Wróć do listy</ui-button
      >
    } @else {
      @if (errorMessage()) {
        <ui-inline-message
          [text]="errorMessage() ?? ''"
          tone="danger"
          ariaLive="polite"
        />
      }

      @if (itemTitle(); as title) {
        <ui-card padding="sm" [elevated]="false">
          <section
            class="wishlist-detail-reservation-drawer__item"
            aria-label="Wybrany prezent"
          >
            <div>
              <p class="wishlist-detail-reservation-drawer__eyebrow">
                Wybrany prezent
              </p>
              <h3>{{ title }}</h3>
              @if (beneficiaryLabel(); as beneficiary) {
                <p>Dla: {{ beneficiary }}</p>
              }
              <p>
                Po potwierdzeniu emaila inni zobaczą, że ten prezent jest
                zarezerwowany.
              </p>
            </div>
          </section>
        </ui-card>
      }

      <ui-input
        label="Email"
        name="wishlistReservationEmail"
        type="email"
        autocomplete="email"
        inputMode="email"
        placeholder="np. babcia@example.com"
        [value]="email()"
        [disabled]="formDisabled()"
        [errorText]="emailError()"
        (valueChange)="handleEmailChanged($event)"
      />

      @if (termsUrl; as url) {
        <a
          class="reservation-terms-link"
          [href]="url"
          target="_blank"
          rel="noopener noreferrer"
        >
          {{
            isQaScenario
              ? 'Przeczytaj testowe zasady rezerwacji'
              : 'Przeczytaj regulamin rezerwacji'
          }}
        </a>
        <ui-checkbox-row
          [title]="
            isQaScenario
              ? 'Potwierdzam testowy scenariusz rezerwacji'
              : 'Akceptuję regulamin rezerwacji'
          "
          [checked]="acceptedTerms()"
          [disabled]="formDisabled()"
          [ariaLabel]="
            isQaScenario
              ? 'Potwierdzam testowy scenariusz rezerwacji'
              : 'Akceptuję regulamin rezerwacji'
          "
          (checkedChange)="handleTermsChanged($event)"
        />
      } @else {
        <ui-inline-message
          text="Regulamin rezerwacji nie jest jeszcze dostępny. Wysyłanie zgłoszeń zostanie włączone po jego publikacji."
          tone="warning"
          ariaLive="polite"
        />
      }

      <ui-button
        size="lg"
        [fullWidth]="true"
        [disabled]="!canSubmit()"
        (pressed)="handleSubmit()"
      >
        @if (pending()) {
          Wysyłam link
        } @else {
          Wyślij link potwierdzający
        }
      </ui-button>

      <p class="wishlist-detail-reservation-drawer__footer-note">
        @if (pending()) {
          Trwa wysyłanie. Poczekaj na wynik przed zamknięciem formularza.
        } @else {
          Prezent zostanie oznaczony jako zarezerwowany dopiero po potwierdzeniu
          emaila.
        }
      </p>
    }
  </div>
</ui-bottom-sheet>
